<app-loading-modal [show]="loading" message="Loading community news..."></app-loading-modal>

<div *ngIf="!loading && visibleNews.length === 0" class="empty-state">
  <i class="bi bi-newspaper empty-icon"></i>
  <h3 class="empty-title">No news yet</h3>
  <p class="empty-text">Stay tuned — fresh updates from the underground are coming soon.</p>
</div>

<div class="news-list" *ngIf="!loading && visibleNews.length > 0">
  <article *ngFor="let item of visibleNews; let i = index" class="news-item" [class.news-item--lead]="i === 0" @fadeInOut>
    <span class="news-date text-label">{{ item.createdAt | date: 'MMM d, y' }}</span>
    <h3 class="news-title" #newsTitle>{{ item.title }}</h3>
    <p class="news-text" [class.news-text--truncated]="isTruncated(item.content)">
      {{ previewText(item.content) }}<span *ngIf="isTruncated(item.content)" class="news-ellipsis" aria-hidden="true"> …</span>
      <span *ngIf="isTruncated(item.content)" class="sr-only"> Continue reading on the community news page.</span>
    </p>
  </article>
</div>
